module.exports = __webpack_public_path__ + "static/media/backend.66fd0bdc.png";